import {
  APPLY_DOCUMENT_SEARCH,
  APPLY_HEAT_MAP_SEARCH,
  APPLY_SEARCH,
  CLEAR_SEARCH_RESULTS,
  GET_HEAT_MAP_PARTNERSHIPS,
  SAVE_DOCUMENT_SEARCH,
  SAVE_SEARCH,
  SET_MAP_DOWNLOAD_LOADING,
  TOGGLE_DOCUMENTS_VISIBLE
} from 'store/actions/search'
import typeToReducer from 'type-to-reducer'

import produce from 'immer'

const initialState = {
  searchResults: {
    results: []
  },
  documentSearchResults: {
    results: []
  },
  heatMapSearchResults: {
    regions: [],
    all_partnerships: [],
    non_eu_partnerships: []
  },
  isPending: true,
  isDocumentsPending: false,
  error: false,
  isDocumentsVisible: false,
  isHeatMapPending: false,
  isHeatMapPartnershipsPending: false,
  heatMapPartnerships: [],
  isMapDownloadPending: false,
  previousSearch: null,
  previousDocumentSearch: null
}

export default typeToReducer(
  {
    [APPLY_SEARCH]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isPending = true
          draft.error = false
          draft.searchResults = {
            results: []
          }
          draft.documentSearchResults = {
            results: []
          }
        }),
      REJECTED: state =>
        produce(state, draft => {
          draft.isPending = false
          draft.error = true
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          if (
            (payload.time && state.searchResults.time < payload.time) ||
            !state.searchResults.time
          ) {
            draft.searchResults = payload
          }
          draft.isPending = false
        })
    },
    [APPLY_DOCUMENT_SEARCH]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isDocumentsPending = true
          draft.error = false
          draft.documentSearchResults = {
            results: []
          }
        }),
      REJECTED: state =>
        produce(state, draft => {
          draft.isDocumentsPending = false
          draft.error = true
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          draft.documentSearchResults = payload
          draft.isDocumentsPending = false
        })
    },
    [APPLY_HEAT_MAP_SEARCH]: {
      PENDING: state =>
        produce(state, draft => {
          const offset = 100
          draft.heatMapTime = Date.now() - offset
          draft.isHeatMapPending = true
          draft.error = false
          draft.heatMapSearchResults = initialState.heatMapSearchResults
        }),
      REJECTED: state =>
        produce(state, draft => {
          draft.isHeatMapPending = false
          draft.error = true
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          if ((payload.time && state.heatMapTime < payload.time) || !state.searchResults.time) {
            draft.heatMapSearchResults = payload
            draft.isHeatMapPending = false
          }
        })
    },
    [GET_HEAT_MAP_PARTNERSHIPS]: {
      PENDING: state =>
        produce(state, draft => {
          draft.isHeatMapPartnershipsPending = true
          draft.error = false
        }),
      REJECTED: state =>
        produce(state, draft => {
          draft.isHeatMapPartnershipsPending = false
          draft.error = true
        }),
      FULFILLED: (state, { payload }) =>
        produce(state, draft => {
          draft.heatMapPartnerships = payload
          draft.isHeatMapPartnershipsPending = false
        })
    },
    [TOGGLE_DOCUMENTS_VISIBLE]: (state, { payload }) => {
      const { isDocumentsVisible } = payload
      return produce(state, draft => {
        draft.isDocumentsVisible = isDocumentsVisible
      })
    },
    [CLEAR_SEARCH_RESULTS]: state =>
      produce(state, draft => {
        draft.searchResults = null
        draft.documentSearchResults = null
      }),
    [SET_MAP_DOWNLOAD_LOADING]: (state, { payload }) => {
      const { isLoading } = payload
      return produce(state, draft => {
        draft.isMapDownloadPending = isLoading
      })
    },
    [SAVE_SEARCH]: (state, { payload }) =>
      produce(state, draft => {
        draft.previousSearch = payload
      }),
    [SAVE_DOCUMENT_SEARCH]: (state, { payload }) =>
      produce(state, draft => {
        draft.previousDocumentSearch = payload
      })
  },
  initialState
)
